











































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import mapSettings from '@/settings/MapSettings';
import { mapOptionsOn, mapOptionsOff } from '@/settings/MapOptions';
import { MapSetting, Marker, InfoWindow, Coordinate } from '@/models/Retailer';
import RetailerSearchBox from './RetailerSearchBox.vue';
import { websiteText } from '@/mixins/websiteTexts';
import { MarkersStore } from '@/store/markersstate';
// import { chunk, concat } from 'lodash';

declare var google: any;

@Component({
    components: {
        RetailerSearchBox
    }
})
export default class RetailerSearch extends Vue {
    @Prop() currentCulture!: string;
    $refs!: {
        googleMap: any;
    };

    protected settings!: MapSetting;
    protected options: any;
    protected singleMarker: boolean = false;
    protected markers: Marker[] = [];
    protected mapMarkerUrl: string;
    protected infoWindow: InfoWindow;
    protected mapMarkersDelay: Marker[] = [];

    constructor() {
        super();
        this.settings = mapSettings;
        this.options = mapOptionsOff;
        this.mapMarkerUrl = '/ui/assets/marker3.svg';
        // MarkersStore.searchRetailer(markers);

        // this.$store.dispatch('searchRetailer', {
        //     searchQuery: '',
        //     pageSize: 'all'
        // });
        this.infoWindow = {
            position: { lat: 0, lng: 0 },
            open: false,
            template: ''
        } as InfoWindow;
    }
    mounted() {
        if (this.$attrs.marker) {
            this.singleMarker = true;
        }
    }

    @Watch('mapMarkers')
    private setFitBounds() {
        this.$refs.googleMap.$mapPromise.then((map: any) => {
            if (this.singleMarker) {
                map.setZoom(15);
                this.centerMarker(this.mapMarkers[0].position);
            } else {
                const bounds = new google.maps.LatLngBounds();
                this.mapMarkers.forEach((marker: Marker) => {
                    bounds.extend(new google.maps.LatLng(marker.position.lat, marker.position.lng));
                });
                map.fitBounds(bounds);
            }
        });
    }

    @Watch('mapMarkers')
    private addMarkersDelay() {
        if (this.mapMarkers.length > 0) {
            this.infoWindow.open = false; // Hide open infowindow after new search
            this.mapMarkersDelay = []; // Reset markers
            this.addDelayMarker();
        }
    }

    private addDelayMarker() {
        // setTimeout(() => {
        const dropAnimationTime = this.mapMarkers.length < 10 ? 1200 : 2000;
        const groupSize = this.mapMarkers.length < 10 ? this.mapMarkers.length : 10;
        const groups = this._.chunk(this.mapMarkers, this.mapMarkers.length / groupSize);
        const delay = dropAnimationTime / groups.length;

        for (let index = 0; index < groups.length; index++) {
            const group = groups[index];
            this.addMarkerWithTimeoutGroup(group, delay * index);

            // for (var i = 0; i < group.length; i++) {
            //     this.addMarkerWithTimeout(group[i], delay * i);
            // }
        }
        // }, 2000);
    }
    // private addMarkerWithTimeout(marker: Marker, timeout: number) {
    //     setTimeout(() => {
    //         this.mapMarkersDelay.push(marker);
    //         console.log('placing marker: ' + marker + ' at: ' + timeout);
    //     }, timeout);
    // }
    private addMarkerWithTimeoutGroup(markers: Marker[], timeout: number) {
        setTimeout(() => {
            this.mapMarkersDelay = this._.concat(this.mapMarkersDelay, markers);
        }, timeout);
    }

    private setMapOptions() {
        this.$refs.googleMap.$mapPromise.then((map: any) => {
            if (map.getZoom() >= 8) {
                this.options = mapOptionsOn;
            } else {
                this.options = mapOptionsOff;
            }
            this.settings.zoom = map.getZoom();
        });
    }

    private centerMarker(coordinate: Coordinate) {
        this.$refs.googleMap.$mapPromise.then((map: any) => {
            // map.panTo(this.mapMarkers[index].position);
            map.setCenter(coordinate);
            // On small devices place marker at bottom
            const mapElem = document.getElementById('map');
            if (mapElem && mapElem.clientWidth < 900) {
                const mapHeight = mapElem.clientHeight;
                const offSetFromBottom = 80;
                map.panBy(0, -(mapHeight / 2 - offSetFromBottom));
            } else {
                map.panBy(-100, 0);
            }
        });
    }

    private toggleInfoWindow(m: Marker, index: number) {
        if (this.singleMarker) {
            return;
        }
        this.infoWindow.open = true;
        this.infoWindow.template = `<div class="map-infowindow-inner"><div class="map-infowindow-heading">${
            m.city
        }</div><div class="map-infowindow-content"><div class="retailer-name">${m.name}</div><a href="${
            m.url
        }" target="${
            m.target
        }" class="cta-button map-infowindow-link" data-action="gaet" data-gaet="{&quot;hitType&quot;:&quot;event&quot;,&quot;category&quot;:&quot;Outbound Links&quot;,&quot;action&quot;:&quot;Retailer Web Link&quot;,&quot;label&quot;:&quot;Ballingslöv | Stockholm City&quot;,&quot;value&quot;:null}" target="_blank">${websiteText(
            'retailer.moreinfo'
        )}</a></div></div>`;
        this.infoWindow.position = {
            lat: m.position.lat,
            lng: m.position.lng
        };
        this.mapMarkers.map(marker => {
            marker.selected = false;
        });
        this.mapMarkers[index].selected = true;
        this.settings.zoom = 14;

        if (this.mapMarkers[index].position) {
            this.centerMarker(this.mapMarkers[index].position);
        }

        const test = websiteText('product.colors');
    }

    get mapMarkers(): Marker[] {
        if (this.singleMarker) {
            const markers: Marker[] = [];
            const markerAttr = (JSON.parse(this.$attrs.marker) as unknown) as Coordinate;
            const marker: Marker = {
                position: {
                    lat: markerAttr.lat,
                    lng: markerAttr.lng
                }
            };
            markers.push(marker);
            return markers;
        }
        return MarkersStore.getMarkers;
    }
}
